import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-builder',
  templateUrl: './builder.component.html',
  styleUrls: ['./builder.component.styl']
})
export class BuilderComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
